import React, { useEffect, useState } from "react";
import { useWizard } from "react-use-wizard";
import { motion } from "framer-motion";
import "../../travel.css";
import Steps from "../steps/Steps";
import { useDispatch, useSelector } from "react-redux";
import { stepActions } from "../../store/Steps";
import { useNavigate } from "react-router-dom";
import { variants } from "../../shared/variants";
import { useMixpanel } from "react-mixpanel-browser";
import { useTranslation } from "react-i18next";
import { MTEK_TRAVEL_MODULE_ID } from "../../../configs/module";

function GetStarted() {
  const { t } = useTranslation();
  const mixpanel = useMixpanel();
  const onGetStartedValue =
    JSON.parse(sessionStorage.getItem("onGetStarted")!) === true;
  const [onGetStarted, onShowGetStartedPage] =
    useState<boolean>(onGetStartedValue);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const tenantCreds = useSelector((state: any) => state.tenantCreds);

  const { nextStep, goToStep } = useWizard();

  const handleOutboundClick = () => {
    sessionStorage.setItem("travel_option", "outbound");
    if (dispatch(stepActions.onAddStep())) {
      nextStep();
    }
  };

  const handleInboundClick = () => {
    sessionStorage.setItem("travel_option", "inbound");
    if (dispatch(stepActions.onAddStep())) {
      nextStep();
    }
  };

  const handleLocalClick = () => {
    sessionStorage.setItem("travel_option", "town");
    if (dispatch(stepActions.onAddStep())) {
      nextStep();
    }
  };
  const getStarted = () => {
    onShowGetStartedPage(true);
    sessionStorage.setItem("onGetStarted", "true");
  };

  const location = window.location.search;
  const generatedQuoteID = new URLSearchParams(location).get(
    "generatedQuoteId",
  );
  const getquotesFromWhatsspp = new URLSearchParams(location).get("getquotes");
  const groupid = new URLSearchParams(location).get("groupid");
  const familyid = new URLSearchParams(location).get("familyid");
  const mxDistinctId = new URLSearchParams(location).get("mxDistinctId");

  const uploadWhattspGroupMembers = () => {
    if (groupid) {
      goToStep(1);
    }
  };

  const uploadWhattspFamilyMembers = () => {
    if (familyid) {
      goToStep(1);
    }
  };

  const goToGetQuotes = () => {
    if (generatedQuoteID || getquotesFromWhatsspp) {
      goToStep(2);
    }
  };

  const getMixPanelDistinctId = () => {
    if (mxDistinctId) {
      sessionStorage.setItem("mxDistinctId", mxDistinctId);
    } else {
      sessionStorage.setItem("mxDistinctId", mixpanel.get_distinct_id());
    }
  };

  useEffect(() => {
    if (mixpanel.config.token) {
      mixpanel.track("PageView", {
        pageName: "Travel|Get-started",
      });
    }
    getMixPanelDistinctId();
    goToGetQuotes();
    uploadWhattspGroupMembers();
    uploadWhattspFamilyMembers();
  }, [
    generatedQuoteID,
    getquotesFromWhatsspp,
    groupid,
    familyid,
    onGetStarted,
    mixpanel,
    mxDistinctId,
  ]);

  return (
    <motion.div variants={variants} initial="enter" animate="center">
      <Steps name="get-started" />
      {onGetStarted && (
        <motion.div
          variants={variants}
          initial="enter"
          animate="center"
          className="get-started-buttons"
        >
          <div className="travel-options">
            <p className="travel-instruction">
              {t("getStarted.question")}
            </p>
            <div className="travel-buttons">
              <button
                className="travel-button me-5"
                onClick={handleInboundClick}
              >
                {t("getStarted.inbound")}
              </button>
              <button
                className="travel-button me-5"
                onClick={handleOutboundClick}
              >
                {t("getStarted.outbound")}
              </button>
              <button className="travel-button" onClick={handleLocalClick}>
                {t("getStarted.local")}
              </button>
            </div>
          </div>
        </motion.div>
      )}
      {!onGetStarted && (
        <motion.div
          variants={variants}
          initial="enter"
          animate="center"
          className="get-started"
        >
          <span className="simple">{t("getStarted.simpleFast")}</span>
          <span className="simple simple-vehicle-details">
            {t("getStarted.provideDetails")}{" "}
            <span className="simple-sticker">{t("getStarted.policyInstantly")}</span>
          </span>
          <button className="button-get-started" onClick={getStarted}>
            {t("getStarted.getStartedBtn")}
          </button>
          {/* <a className="view-policies" onClick={() => navigate("/policies")}>
            View Policies
          </a> */}
        </motion.div>
      )}
      {tenantCreds?.moduleId === MTEK_TRAVEL_MODULE_ID && !onGetStarted && (
        <div style={{
          color: "#170F4F",
          textAlign: "center",
          fontFamily: "Roboto",
          fontSize: "12px",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "normal",
          marginBottom: "40px",
          padding: "0 20px",
        }} className="steps-container">
          Bolttech is a brand used by HILLCROFT TECHNOLOGIES LIMITED, with the trade name MTEK Services (Company No. CPR/2015/203028), a company incorporated in Kenya, and having its business address at Starwood Apartments, Building: LR NO 1/500, Nairobi, Kenya.
        </div>
      )}

    </motion.div>
  );
}

export default GetStarted;
